import Button from "components/global/Button";
import Spacer from "components/global/Spacer";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 18px 24px;
  background-color: var(--background);

  .add-prompt {
    color: var(--grey_8);
  }

  .prompt-btn {
    background-color: var(--secondary);
    height: 36px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }

  .form {
    input {
      background-color: inherit;
      width: 100%;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      color: var(--grey_1);
      padding: 8px 0;
      border: none;

      &::placeholder {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        color: var(--grey_6);
      }
    }

    .description-input {
      background-color: inherit;
      width: 100%;
      padding: 8px 0;
      font-size: 14px;
      color: var(--body_text);
      font-weight: 450;
      line-height: 20px;
      max-height: 56px;
      border: none;
      &::placeholder {
        font-size: 14px;
        font-weight: 450;
        line-height: 20px;
        color: var(--grey_6);
      }
    }

    .button-row {
      justify-content: flex-end;
      gap: 16px;

      button {
        font-size: 14px;
      }
    }
  }
`;

const FeatureForm = ({
  setFeatureTitle,
  setFeatureDescription,
  handleSubmit,
  featureTitle,
  featureDescription,
  showForm,
  setShowForm,
  isSubmitting,
}) => {
  return (
    <Wrapper>
      {!showForm && (
        <div 
          className="add-prompt flexRow alignCenter justifySpaceBetween" 
          onClick={() => setShowForm(true)}
        >
          <p>Share your feature suggestion...</p>
          <button className="prompt-btn" onClick={() => setShowForm(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00039 2.3999C8.44222 2.3999 8.80039 2.75807 8.80039 3.1999V7.1999H12.8004C13.2422 7.1999 13.6004 7.55807 13.6004 7.9999C13.6004 8.44173 13.2422 8.7999 12.8004 8.7999H8.80039V12.7999C8.80039 13.2417 8.44222 13.5999 8.00039 13.5999C7.55856 13.5999 7.20039 13.2417 7.20039 12.7999V8.7999H3.20039C2.75856 8.7999 2.40039 8.44173 2.40039 7.9999C2.40039 7.55807 2.75856 7.1999 3.20039 7.1999H7.20039V3.1999C7.20039 2.75807 7.55856 2.3999 8.00039 2.3999Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      )}

      {showForm && (
        <form className="form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Short, descriptive title"
            value={featureTitle}
            onChange={(e) => setFeatureTitle(e.target.value)}
          />
          <Spacer y={0.4} />
          <textarea
            className="description-input"
            placeholder="Add a detailed description, and let us know how it will benefit others..."
            value={featureDescription}
            onChange={(e) => setFeatureDescription(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(e);
              }
            }}
          />

          <div className="button-row flexRow">
            <Button
              text="Cancel"
              height="36px"
              type="button"
              className="borderedGrey"
              onClick={() => {
                setFeatureDescription("");
                setFeatureTitle("");
                setShowForm(false);
              }}
            />
            <Button
              text="Submit"
              height="36px"
              type="submit"
              disabled={!featureTitle || !featureDescription || isSubmitting}
            />
          </div>
        </form>
      )}
    </Wrapper>
  );
};

export default FeatureForm;
